import { useContext } from 'react';
import { NotificationsContext } from 'providers/context';

export default function useNotifications(context = NotificationsContext) {
  return useContext(context);
}
